// extracted by mini-css-extract-plugin
export default {"base":"vp_E1nba","textAlignRight":"vp_zvdvs","textAlignLeft":"vp_bVEWg"};